import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=0c200b60"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=0c200b60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports